'use client';

import type { CryptoDetail, CryptoTokenBase } from '@/type/crypto';
import { cryptoPriceFormatter } from '@/lib/utils';
import { ChangeText } from '../cards/ChangeText';
import { useTranslation } from '@/lib/i18n';
import { Avatar } from '@mui/material';

interface CryptoHeaderProps {
  data?: Partial<CryptoDetail> | Partial<CryptoTokenBase>;
}

export default function CryptoHeader({ data }: CryptoHeaderProps) {
  const { t } = useTranslation();
  const symbolName = data?.name || data?.symbol || '';
  const price = data?.price;
  const change24h = data?.percent_change_24h || 0;

  return (
    <header className="">
      <div className="flex items-center gap-3">
        <Avatar
          src={data?.logo_url || undefined}
          alt={symbolName}
          sx={{ width: 58, height: 58, bgcolor: 'rgba(255,255,255,.1)' }}
        >
          {symbolName.slice(0, 1).toUpperCase()}
        </Avatar>
        <span className="text-2xl font-bold leading-none tracking-normal text-white uppercase">
          {symbolName}
        </span>
      </div>

      <div className="mt-5 flex items-center gap-3">
        <span className="text-2xl font-bold leading-none tracking-normal text-white">
          {price ? `$${cryptoPriceFormatter(price)}` : '--'}
        </span>
        <ChangeText value={change24h} />
        <span className="text-xs font-semibold leading-none text-[#737d86] -ml-2">
          ({t('24h')})
        </span>
      </div>
    </header>
  );
}
